import type { HTMLAttributes } from 'react';

export interface Props extends HTMLAttributes<HTMLLIElement> {
  itemData: {
    name: string;
    [otherProps: string]: unknown;
  };
}

const SortableListItem = ({ itemData, ...otherProps }: Props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <li {...otherProps} />
);

export default SortableListItem;
